module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey darken-3"
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "orange"
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab1"
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                    Stammdaten\n                ")])], 1), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab2"
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                    Logos\n                ")])], 1), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab3"
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n                    Typen & Warengruppen\n                ")])], 1), _vm._v(" "), _c('v-tabs-slider', {
    staticClass: "orange"
  })], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', [_c('keep-alive', [_c('form-one', {
    on: {
      "submitted": _vm.submitForm
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', [_c('keep-alive', [_c('form-two', {
    on: {
      "submitted": _vm.submitForm
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', [_c('keep-alive', [_c('form-three', {
    on: {
      "submitted": _vm.submitForm
    }
  })], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eca212f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marken/editMarken.vue
// module id = 353
// module chunks = 0